import dayjs from "dayjs";

export const BATCH_REPORT_DEFAULT_STATUS = "All";

// Helper function to get the default selected date (yesterday)
export const getDefaultBatchReportSelectedDate = () => new Date(new Date().setDate(new Date().getDate() - 1));

// Helper function to check if a date is valid
export const isValidBatchReportDate = (date) => date !== "" && date !== "Invalid date" && date != null;

export const getBatchReportCalendarDay = (date) => {
  if (!isValidBatchReportDate(date)) {
    return null;
  }
  return dayjs(date).format("YYYY-MM-DD");
};

/** True when the date matches the default list load (yesterday). */
export const isDefaultBatchReportSelectedDate = (selectedDate) => {
  const selectedDay = getBatchReportCalendarDay(selectedDate);
  const defaultDay = getBatchReportCalendarDay(getDefaultBatchReportSelectedDate());
  return selectedDay != null && defaultDay != null && selectedDay === defaultDay;
};

/**
 * Returns which list-query filters differ from their defaults (non-default only).
 * Excludes view tabs and search fields — those selections are already visible in the control.
 * @param {Object} batchReportState
 * @returns {Set<string>}
 */
export const getActiveBatchReportFilterKeys = (batchReportState) => {
  const activeKeys = new Set();
  const {
    overDueResults,
    readyResults,
    dueByResults,
    selectedDate,
    resultsDueDate,
    selectedOption,
  } = batchReportState;

  if (overDueResults) {
    activeKeys.add("overdue");
  }
  if (readyResults) {
    activeKeys.add("ready");
  }
  if (dueByResults && isValidBatchReportDate(resultsDueDate)) {
    activeKeys.add("dueBy");
  }

  if (!overDueResults && !readyResults && !dueByResults) {
    if (isValidBatchReportDate(selectedDate) && !isDefaultBatchReportSelectedDate(selectedDate)) {
      activeKeys.add("date");
    }
  }

  if (selectedOption !== BATCH_REPORT_DEFAULT_STATUS) {
    activeKeys.add("status");
  }

  return activeKeys;
};

// Helper function to get the class name for the filter field
export const getBatchReportFilterFieldClassName = (isActive) => (isActive ? "batchReportFilterField batchReportFilterField--active" : "batchReportFilterField");

// Helper function to get the class name for the mode button
export const getBatchReportsModeButtonClassName = (baseClassName, isActive) => (isActive ? `${baseClassName} batchReportsModeBtn--active` : baseClassName);
